const request = require("request");
const config = require("./config");

const get = (token, filters) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          "Content-Type": "application/json",
          "User-Token": token,
        },
        uri: `${config.URL_BACKEND}/condicoesGrupo/${filters.idOrg}`,
        method: 'GET'
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

var PostOpcaoReceb = (obj, token) => {
  return new Promise((resolve, reject) => {
    request(
      {
        headers: {
          "Content-Type": "application/json",
          "User-Token": token,
        },
        timeout: 2500,
        uri: `${config.URL_BACKEND}/condicoesGrupo`,
        method: "POST",
        body: obj,
      },
      (err, res, body) => {
        resolve({ err: err, res: res, body: body });
      }
    );
  });
};

module.exports = {
  get: get,
  PostOpcaoReceb: PostOpcaoReceb,
};
